import { FilterFieldOperator } from '@/components/table/_filterFieldOperators/FilterFieldOperator.ts';

export const operatorDisplayName = (operator: FilterFieldOperator): string => {
  switch (operator) {
    case FilterFieldOperator.EQUALS:
      return 'równa się';
    case FilterFieldOperator.NOT_EQUALS:
      return 'nie równa się';
    case FilterFieldOperator.BETWEEN:
      return 'pomiędzy';
    case FilterFieldOperator.CONTAINS:
      return 'zawiera';
    case FilterFieldOperator.NOT_CONTAIN:
      return 'nie zawiera';
    case FilterFieldOperator.GREATER_THAN:
      return 'większe niż';
    case FilterFieldOperator.GREATER_THAN_OR_EQUALS:
      return 'większe lub równe niż';
    case FilterFieldOperator.LESS_THAN:
      return 'mniejsze niż';
    case FilterFieldOperator.LESS_THAN_OR_EQUALS:
      return 'mniejsze lub równe niż';
    case FilterFieldOperator.IS:
      return 'jest';
    case FilterFieldOperator.IS_NOT:
      return 'nie jest';
    default:
      return operator;
  }
};
